import {
    DEFAULT_PRODUCTS_LIST_PARAMETERS,
    DEFAULT_USER_COMPLETED_PRODUCTS_LIST_PARAMETERS,
    DEFAULT_USER_ON_REVIEW_PRODUCTS_LIST_PARAMETERS,
} from '@entities/product/config/store-constants';
import { TabValues } from '../../config/ui-constants';
import { SearchSortParameter } from '@shared/ui/search/types';

export const sortParametersAfterClearSearch = (activeTab: string): SearchSortParameter | undefined => {
    switch (activeTab) {
        case TabValues.Catalog: {
            return {
                sort: DEFAULT_PRODUCTS_LIST_PARAMETERS.sort,
                order: DEFAULT_PRODUCTS_LIST_PARAMETERS.order,
            };
        }
        case TabValues.Completed: {
            return {
                sort: DEFAULT_USER_COMPLETED_PRODUCTS_LIST_PARAMETERS.sort,
                order: DEFAULT_USER_COMPLETED_PRODUCTS_LIST_PARAMETERS.order,
            };
        }
        case TabValues.Review: {
            return {
                sort: DEFAULT_USER_ON_REVIEW_PRODUCTS_LIST_PARAMETERS.sort,
                order: DEFAULT_USER_ON_REVIEW_PRODUCTS_LIST_PARAMETERS.order,
            };
        }
    }
};
